const replaceApplicationStatePlaceholders = (data, applicationState) => {
  if (typeof data === 'string') {
    ;(data.match(/({.+?})/g) || []).forEach(placeholder => {
      if (
        Object.prototype.hasOwnProperty.call(
          applicationState,
          placeholder.slice(1, -1)
        )
      ) {
        data = data.replace(
          placeholder,
          applicationState[placeholder.slice(1, -1)] || ''
        )
      } else {
        data = data.replace(placeholder, '')
      }
    })

    return data
  } else if (Array.isArray(data)) {
    return data.map(param => {
      if (typeof param === 'object') {
        return replaceApplicationStatePlaceholders(param, applicationState)
      }
      return /^{.+}$/.test(param) ? applicationState[param.slice(1, -1)] : param
    })
  } else if (typeof data === 'object') {
    data = { ...data }

    for (const param in data) {
      if (
        Object.prototype.hasOwnProperty.call(data, param) &&
        /^{.+}$/.test(data[param]) &&
        applicationState.hasOwnProperty(data[param].slice(1, -1))
      ) {
        data[param] = applicationState[data[param].slice(1, -1)]
      }
    }

    return data
  }

  return {}
}

export default replaceApplicationStatePlaceholders
